import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import ReactDOM from 'react-dom/client'

import { App } from './App'
import Auth0ProviderWithNavigate from './auth/auth0-provider-with-navigate'
import LocalAuthProvider, { isLocalAuthEnabled } from './auth/local-auth-provider'
import reportWebVitals from './reportWebVitals'
import './index.scss'

// Local testing only (.env.local-dev): sign in against the local harness instead of
// Auth0. With REACT_APP_LOCAL_AUTH unset, the real Auth0 provider is used as before.
const AuthProvider = isLocalAuthEnabled()
  ? LocalAuthProvider
  : Auth0ProviderWithNavigate

const container = document.getElementById('root') as HTMLElement
const root = ReactDOM.createRoot(container)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
